import { createSelector } from 'reselect'

export const getSsoState = state => state.sso

export const selectSsoError = createSelector(getSsoState, state => state.error)
